// Entry point for the build script in your package.json
import * as bootstrap from "bootstrap"

// Application JS Files
import ContentProcessor from './content_processor';

document.modalZIndex = 1055;

function toggleByData(event) {
  event.preventDefault();
  const toggleData = event.currentTarget.dataset.toggleTarget;
  const toggleables = document.querySelectorAll(`[data-toggle="${toggleData}"]`);
  for (let i = 0; i < toggleables.length; i++) {
    if (toggleables[i].classList.contains('d-none')) {
      toggleables[i].classList.remove('d-none');
    } else {
      toggleables[i].classList.add('d-none');
    }
  }
}

function showModal(modalEl) {
  document.modalZIndex += 1;
  modalEl.modal.show();
  modalEl.style.zIndex = document.modalZIndex;
}

function getViaAjax(event) {
  event.preventDefault();

  const clickEl = event.currentTarget;
  if (clickEl.classList.contains('get-via-ajax-once')) {
    clickEl.classList.remove('get-via-ajax', 'get-via-ajax-once');
    clickEl.removeEventListener('click', getViaAjax);
  }

  const endpoint = clickEl.getAttribute('href') || clickEl.getAttribute('path');
  let containerEl = clickEl;

  switch (clickEl.getAttribute('display-as')) {
  case 'inline':
    // Default state, but we still want it set.
    // Note that the container IS the clickEl here!
    break;
  case 'modal':
    const modalId = clickEl.getAttribute('modal-id');
    let modalEl = document.getElementById(modalId);
    if (modalEl) {
      showModal(modalEl);
      return;
    }
    const baseModal = document.getElementById(clickEl.getAttribute('base-modal-id'));
    modalEl = baseModal.cloneNode(true);
    modalEl.id = modalId;
    document.body.append(modalEl);
    const modal = new bootstrap.Modal(modalEl, {});
    modalEl.modal = modal;
    modal.show();
    containerEl = modal._dialog;
    break;
  default:
    console.error('No valid display-as set!');
    return;
  }

  fetch(endpoint).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  }).then((response) => { 
    if (response.success) {
      const contentProcessor = new ContentProcessor(containerEl, {
        getViaAjax: {
          class: '.get-via-ajax', event: 'click', function: getViaAjax
        },
        truncateTogglerClick: {
          class: '.truncation-toggler', event: 'click', function: truncateTogglerClick
        },
      });
      contentProcessor.processData(response.data);
    } else {
      // Display any relevant errors
      if (response.errors) {
        for (let i = 0; i < response.errors.length; i++) {
          console.error(response.errors[i]);
        }
      }

      if (response.backtrace) {
        console.error(response.backtrace);
      }

      if (response.message) {
        alert(response.message);
      }
    }
  });
}

function userRatingUpdated(formEl, data) {
  formEl.querySelector('[name="seen"]').value = !data.seen;
  formEl.classList.remove('list-group-item-unknown');
  const eyeIcon = formEl.querySelector('.seen-icon');
  eyeIcon.classList.remove('bi-eye-slash');
  if (data.seen) {
    formEl.classList.remove('list-group-item-warning');
    formEl.classList.add('list-group-item-success');
    eyeIcon.classList.remove('bi-eye-slash-fill');
    eyeIcon.classList.add('bi-eye-fill');
  } else {
    formEl.classList.remove('list-group-item-success');
    formEl.classList.add('list-group-item-warning');
    eyeIcon.classList.remove('bi-eye-fill');
    eyeIcon.classList.add('bi-eye-slash-fill');
  }
}

function addedItemToList(formEl) {
  const submitBtn = formEl.querySelector('button[type="submit"]');
  submitBtn.classList.remove('btn-success');
  submitBtn.classList.add('btn-outline-success');
  submitBtn.disabled = true;
  submitBtn.innerHTML = 'In List';
}

function removeHtmlId(formEl, data) {
  const el = document.getElementById(data.id);
  if (el) {
    el.remove();
  }
}

function toggleItemToSubList(formEl) {
  const wrapper = formEl.closest('.sub-list-actions');
  // I'm ASSUMING there's only one of these...
  const siblingForm = wrapper.querySelector('form.d-none');
  siblingForm.classList.remove('d-none');
  formEl.classList.add('d-none');
}

function ajaxFormHandler(event) {
  event.preventDefault();

  const formEl = event.currentTarget;
  const submitBtn = formEl.querySelector('button[type="submit"]');
  if (submitBtn) submitBtn.disabled = true;
  if (formEl.awaitingSubmit) return;

  formEl.awaitingSubmit = true;

  const responseFuncs = {
    addedItemToList: addedItemToList,
    userRatingUpdated: userRatingUpdated,
    removeHtmlId: removeHtmlId,
    toggleItemToSubList: toggleItemToSubList,
  };

  fetch(formEl.action, {
    method: formEl.method,
    body: new FormData(formEl),
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return response.json();
  }).then((response) => {
    if (!response.success) {
      // Display any relevant errors
      if (response.errors) {
        for (let i = 0; i < response.errors.length; i++) {
          console.error(response.errors[i]);
        }
      }

      if (response.backtrace) {
        console.error(response.backtrace);
      }

      if (response.message) {
        alert(response.message);
      }
      return;
    }

    formEl.awaitingSubmit = false;

    if (response.function) {
      // Call a func if there is one
      const cleanedFunc = response.function.replace(/[\W]*/, '');
      if (typeof responseFuncs[cleanedFunc] === 'function') {
        responseFuncs[cleanedFunc](formEl, response.data);
      }
    }
  });
}

function submitOnClickClick(event) {
  event.preventDefault();
  if (event.currentTarget.dataset.confirm) {
    if (!confirm(event.currentTarget.dataset.confirm)) {
      return;
    }
  }

  const form = event.currentTarget.closest('form');
  if (form.classList.contains('submit-via-ajax')) {
    form.dispatchEvent(new Event('submit'));
  } else {
    form.submit();
  }
}

function randomBtnClick(event) {
  event.preventDefault();
  event.stopPropagation();

  const btn = event.currentTarget;
  const input = btn.querySelector('input[name="r"]');
  input.value = 'y';
  btn.closest('form').submit();
}

function subListSelectChange(event) {
  const form = event.currentTarget.closest('form');

  const input = form.querySelector('.filter-to-sublist--check');
  input.disabled = event.currentTarget.value == '';
  input.dispatchEvent(new Event('change'));
}

function subListFilterChange(event) {
  const form = event.currentTarget.closest('form');
  const radioWrappers = form.querySelectorAll('.filter-to-sublist--user-radio');
  const radios = form.querySelectorAll('.filter-to-sublist--user-radio input');

  if (event.currentTarget.checked && !event.currentTarget.disabled) {
    // If we're checked and NOT disabled then we can display the radios
    for (let i = 0; i < radioWrappers.length; i++) {
      radioWrappers[i].classList.remove('d-none');
    }
    for (let i = 0; i < radios.length; i++) {
      radios[i].disabled = false;
    }
  } else {
    // Otherwise we have some combination that says the radios should be hidden and disabled
    for (let i = 0; i < radioWrappers.length; i++) {
      radioWrappers[i].classList.add('d-none');
    }
    for (let i = 0; i < radios.length; i++) {
      radios[i].disabled = true;
    }
  }
}

function truncateTogglerClick(event) {
  const togglerEl = event.currentTarget;
  const wrapper = togglerEl.closest('.truncation-wrapper');
  if (togglerEl.classList.contains('collapsed')) {
    const truncateEl = wrapper.querySelector('.text-truncate');
    togglerEl.classList.remove('collapsed');
    truncateEl.classList.remove('text-truncate');
    togglerEl.classList.add('expanded');
    truncateEl.classList.add('text-expanded');
  } else {
    const truncateEl = wrapper.querySelector('.text-expanded');
    togglerEl.classList.remove('expanded');
    truncateEl.classList.remove('text-expanded');
    togglerEl.classList.add('collapsed');
    truncateEl.classList.add('text-truncate');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const submitOnClicks = document.querySelectorAll('.submit-on-click');
  for (let i = 0; i < submitOnClicks.length; i++) {
    submitOnClicks[i].addEventListener('click', submitOnClickClick);
  }

  const dataToggles = document.querySelectorAll('.toggle-by-data');
  for (let i = 0; i < dataToggles.length; i++) {
    dataToggles[i].addEventListener('click', toggleByData);
  }

  const getViaAjaxItems = document.querySelectorAll('.get-via-ajax');
  for (let i = 0; i < getViaAjaxItems.length; i++) {
    getViaAjaxItems[i].addEventListener('click', getViaAjax);
  }

  const truncateTogglerEls = document.querySelectorAll('.truncation-toggler');
  for (let i = 0; i < truncateTogglerEls.length; i++) {
    truncateTogglerEls[i].addEventListener('click', truncateTogglerClick);
  }

  const ajaxForms = document.querySelectorAll('.submit-via-ajax');
  for (let i = 0; i < ajaxForms.length; i++) {
    ajaxForms[i].addEventListener('submit', ajaxFormHandler);
  }

  const stopEvents = document.querySelectorAll('.stop-event-bubbling');
  for (let i = 0; i < stopEvents.length; i++) {
    stopEvents[i].dataset.events.split(',').forEach((eventType) => {
      stopEvents[i].addEventListener(eventType, (event) => {
        event.stopPropagation();
      });
    })
  }

  const randomBtns = document.querySelectorAll('.random-button');
  for (let i = 0; i < randomBtns.length; i++) {
    randomBtns[i].addEventListener('click', randomBtnClick);
  }

  const subListSelects = document.querySelectorAll('.sub-list--select');
  for (let i = 0; i < subListSelects.length; i++) {
    subListSelects[i].addEventListener('change', subListSelectChange);
  }

  const subListFilterChecks = document.querySelectorAll('.filter-to-sublist--check');
  for (let i = 0; i < subListFilterChecks.length; i++) {
    subListFilterChecks[i].addEventListener('change', subListFilterChange);
  }

  const watchProviderSetAllShowBtn = document.getElementById('watch-provider__set-all-btn--show');
  if (watchProviderSetAllShowBtn) {
    watchProviderSetAllShowBtn.addEventListener('click', (event) => {
      const radios = document.querySelectorAll('.watch-provider__radio--show');
      for (let i = 0; i < radios.length; i++) {
        radios[i].checked = true;
      }
    });
  }

  const watchProviderSetAllUnsubscribedBtn = document.getElementById('watch-provider__set-all-btn--unsubscribed');
  if (watchProviderSetAllUnsubscribedBtn) {
    watchProviderSetAllUnsubscribedBtn.addEventListener('click', (event) => {
      const radios = document.querySelectorAll('.watch-provider__radio--unsubscribed');
      for (let i = 0; i < radios.length; i++) {
        radios[i].checked = true;
      }
    });
  }

  const watchProviderSetAllHideBtn = document.getElementById('watch-provider__set-all-btn--hide');
  if (watchProviderSetAllHideBtn) {
    watchProviderSetAllHideBtn.addEventListener('click', (event) => {
      const radios = document.querySelectorAll('.watch-provider__radio--hide');
      for (let i = 0; i < radios.length; i++) {
        radios[i].checked = true;
      }
    });
  }

  const backToTopContainer = document.getElementById('back-to-top__container');
  const backToTopBtn = document.getElementById('back-to-top__btn');
  const backToTopTarget = document.getElementById('back-to-top__target');
  if (backToTopContainer && backToTopBtn && backToTopTarget) {
    document.addEventListener('scroll', (event) => {
      if (window.scrollY > (window.innerHeight * 2)) {
        backToTopContainer.classList.remove('d-none');
      } else {
        backToTopContainer.classList.add('d-none');
      }
    });
    backToTopBtn.addEventListener('click', (event) => {
      backToTopTarget.scrollIntoViewIfNeeded();
    });
  }

  // Prevent aria-hidden warning when closing modals.
  document.addEventListener('hide.bs.modal', function(event) {

    document.modalZIndex -= 1;
    event.target.style.zIndex = document.modalZIndex;
    if (document.activeElement) {
      document.activeElement.blur();
    }
  });
});
